(function () {
    'use strict';

    angular.module('app.filterTypes', [
        'app.core',
        'app.widgets'
    ]);
})();
